import React from 'react'
import { classNames } from '@app/utils/classes'
import { GrMail } from 'react-icons/gr'
import { useTranslation } from '@app/lib/hooks/useTranslation'

const classes = {
  sticky:
    'fixed flex justify-center bottom-14 left-0 right-0 z-10 pointer-events-none',
  container: 'border-4 p-3',
  text: 'font-semibold text-lg',
  btn: 'flex rounded place-items-center px-2 py-1 bg-gray-200 dark:bg-gray-800 hover:text-white dark:hover:text-blue-600 hover:bg-blue-600 dark:hover:bg-gray-700 focus:text-indigo-600 focus:border-indigo-600',
}

interface Props {
  sendEmail?(): void
  visible?: boolean
}

function ConfirmEmail({ sendEmail, visible }: Props) {
  const { t } = useTranslation('dashboard-modal')

  return !!visible ? (
    <div className={classNames(classes.sticky, 'px-2')}>
      <div
        className={classNames(
          classes.container,
          'flex rounded bg-white items-center dark:bg-black space-x-3 shadow-xl pointer-events-auto'
        )}
      >
        <div className={classNames(classes.text, 'text-sm md:text-lg')}>
          {t('cemail')}
        </div>
        {sendEmail ? (
          <button
            onClick={sendEmail}
            title={'Resend email confirmation'}
            className={classes.btn}
            type={'button'}
          >
            <GrMail className='grIcon' />
            <p className={classNames(classes.text, 'ml-2')}>{t('resend')}</p>
          </button>
        ) : null}
      </div>
    </div>
  ) : null
}

export { ConfirmEmail }
